import { Theme } from '@mui/material';

export const muiThemeData = (): Theme => {
    return JSON.parse(`{
  "muiThemeOptions": {
    "palette": {
      "primary": {
        "main": "#f76c6c",
        "contrastText": "#ffffff"
      },
      "secondary": {
        "main": "#114b5f"
      },
      "error": {
        "main": "#dc3545"
      },
      "warning": {
        "main": "#ffc107"
      },
      "info": {
        "main": "#17a2b8"
      },
      "success": {
        "main": "#28a745"
      },
      "background": {
        "paper": "#ffffff",
        "default": "#114b5f"
      },
      "text": {
        "disabled": "#54565a"
      }
    },
    "shape": {
      "borderRadius": 5
    },
    "typography": {
      "fontFamily": "Open Sans",
      "h1": {
        "color": "#f76c6c"
      },
      "h2": {
        "color": "#f76c6c"
      },
      "h3": {
        "color": "#114b5f"
      },
      "h4": {
        "color": "#114b5f"
      },
      "h5": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "h6": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "subtitle1": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "subtitle2": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "body1": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "body2": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "button": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "caption": {
        "color": "rgba(0, 0, 0, 0.87)"
      },
      "overline": {
        "color": "rgba(0, 0, 0, 0.87)"
      }
    }
  },
  "elementStyles": {
    "footer": {
      "backgroundColor": "#114b5f",
      "color": "#ffffff"
    },
    "header": {
      "backgroundColor": "#114b5f",
      "color": "#ffffff"
    },
    "headerLogo": {
      "height": "49px",
      "width": "150px",
      "background": "url('https://davies-group.com/wp-content/uploads/2020/05/Davies-RGB-White.svg') no-repeat center center/contain"
    },
    "buttonCta": {
      "color": "#ffffff",
      "backgroundColor": "#f76c6c",
      "borderColor": "transparent",
      "borderRadius": "5px",
      "borderWidth": "0px",
      "borderStyle": "none",
      "&:hover": {
        "color": "#ffffff",
        "borderColor": "transparent",
        "borderRadius": "5px",
        "borderWidth": "0px",
        "borderStyle": "none",
        "backgroundColor": "#faa7a7"
      }
    },
    "buttonGhost": {
      "color": "#ffffff",
      "backgroundColor": "#114b5f",
      "borderColor": "transparent",
      "borderRadius": "5px",
      "borderWidth": "0px",
      "borderStyle": "none",
      "&:hover": {
        "color": "#ffffff",
        "borderColor": "transparent",
        "borderRadius": "5px",
        "borderWidth": "0px",
        "borderStyle": "none",
        "backgroundColor": "#70939f"
      }
    },
    "buttonText": {
      "color": "#114b5f",
      "backgroundColor": "transparent",
      "borderColor": "transparent",
      "borderRadius": "0px",
      "borderWidth": "0px",
      "borderStyle": "none",
      "textTransform": "none",
      "&:hover": {
        "color": "#114b5f",
        "backgroundColor": "transparent",
        "borderColor": "transparent",
        "borderRadius": "0px",
        "borderWidth": "0px",
        "borderStyle": "none",
        "textDecoration": "underline"
      }
    },
    "checkbox": {
      "&.Mui-checked": {
        "color": "#114b5f"
      }
    },
    "radio": {
      "&.Mui-checked": {
        "color": "#114b5f"
      }
    },
    "optionButton": {
      "color": "#114b5f",
      "backgroundColor": "#ffffff",
      "borderColor": "#114b5f",
      "borderRadius": "5px",
      "borderWidth": "1px",
      "borderStyle": "solid",
      "&:hover": {
        "color": "#70939f",
        "backgroundColor": "#f8f9fa",
        "borderColor": "#70939f",
        "borderRadius": "5px",
        "borderWidth": "1px",
        "borderStyle": "solid"
      },
      "&.MuiButton-contained": {
        "color": "#ffffff",
        "backgroundColor": "#114b5f",
        "borderColor": "#114b5f",
        "borderRadius": "5px",
        "borderWidth": "1px",
        "borderStyle": "solid",
        "&:hover": {
          "color": "#f8f9fa",
          "backgroundColor": "#70939f",
          "borderColor": "#70939f",
          "borderRadius": "5px",
          "borderWidth": "1px",
          "borderStyle": "solid"
        }
      }
    },
    "progressBar": {
      "color": "#f76c6c",
      "backgroundColor": "#54565a"
    },
    "messageBox": {
      "color": "#ffffff",
      "backgroundColor": "#f76c6c"
    },
    "pageDivider": {
      "borderColor": "#54565a",
      "borderRadius": "0px",
      "borderWidth": "3px",
      "borderStyle": "dashed"
    },
    "optionButtonAlternate": {
      "width": "4em",
      "height": "4em",
      "color": "#114b5f",
      "backgroundColor": "#ffffff",
      "borderColor": "#114b5f",
      "borderRadius": "50%",
      "borderWidth": "1px",
      "borderStyle": "solid",
      "&:hover": {
        "color": "#70939f",
        "backgroundColor": "#f8f9fa",
        "borderColor": "#70939f",
        "borderRadius": "50%",
        "borderWidth": "1px",
        "borderStyle": "solid"
      },
      "&.MuiButton-contained": {
        "color": "#ffffff",
        "backgroundColor": "#114b5f",
        "borderColor": "#114b5f",
        "borderRadius": "50%",
        "borderWidth": "1px",
        "borderStyle": "solid",
        "&:hover": {
          "color": "#f8f9fa",
          "backgroundColor": "#70939f",
          "borderColor": "#70939f",
          "borderRadius": "50%",
          "borderWidth": "1px",
          "borderStyle": "solid"
        }
      }
    },
    "tabs": {
      "& .MuiTabs-indicator": {
        "backgroundColor": "#114b5f"
      }
    },
    "tab": {
      "fontWeight": 500,
      "color": "inherit",
      "opacity": 0.6,
      "&.Mui-selected": {
        "fontWeight": 900,
        "color": "inherit",
        "opacity": 1
      }
    },
    "textField": {
      "backgroundColor": "transparent",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          "borderColor": "#54565a",
          "borderRadius": "5px",
          "borderWidth": "1px",
          "borderStyle": "solid"
        },
        "&.Mui-focused": {
          "backgroundColor": "#f8f9fa",
          "& fieldset": {
            "borderColor": "#f76c6c",
            "borderRadius": "5px",
            "borderWidth": "1px",
            "borderStyle": "solid"
          }
        }
      }
    },
    "select": {
      "backgroundColor": "#ffffff",
      "& fieldset": {
          "&.MuiOutlinedInput-notchedOutline": {
          "borderColor": "rgba(0, 0, 0, 0.87)",
          "borderRadius": "5px",
          "borderWidth": "1px",
          "borderStyle": "solid"
        }
      },
      "&.Mui-focused": {
        "backgroundColor": "#f8f9fa",
        "& fieldset": {
          "&.MuiOutlinedInput-notchedOutline": {
              "borderColor": "#f76c6c",
              "borderRadius": "5px",
              "borderWidth": "1px",
              "borderStyle": "solid"
          }
        }
      },
      "&:hover": {
        "backgroundColor": "#ffffff",
        "& fieldset": {
          "&.MuiOutlinedInput-notchedOutline": {
              "borderColor": "#f76c6c",
              "borderRadius": "5px",
              "borderWidth": "1px",
              "borderStyle": "solid"
          }
        }
      }
    },
    "fileUploader": {
      "main": {
        "color": "rgba(0, 0, 0, 0.87)",
        "backgroundColor": "#ffffff"
      },
      "fileUploadItem": {
        "color": "rgba(0, 0, 0, 0.87)",
        "backgroundColor": "#ffffff"
      },
      "cloudUploadIcon": {
        "color": "#f76c6c"
      },
      "articleIcon": {
        "color": "#f76c6c"
      },
      "deleteIcon": {
        "color": "#dc3545"
      },
      "circularProgress": {
        "color": "#f76c6c"
      }
    },
    "backgroundCard": {
      "backgroundColor": "#ffffff",
      "boxShadow": "rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px",
      "borderColor": "transparent",
      "borderRadius": "5px",
      "borderWidth": "0px",
      "borderStyle": "none"
    }
  },
  "fontFamilies": [
    "Open Sans"
  ]
}`);
};
